/**
 * The exact text a wallet signs to prove ownership when linking to a player.
 * Shared by the client (WalletManager) and the server (functions/lib/wallet-link.js):
 * any change here changes both sides together.
 *
 * @param {{ handle: string, wallet: string, issuedAt: string }} params
 * @returns {string}
 */
export function walletLinkMessage({ handle, wallet, issuedAt }) {
  return [
    "Woodchuck wallet link",
    `Handle: ${handle}`,
    `Wallet: ${wallet}`,
    `Issued: ${issuedAt}`,
  ].join("\n");
}
